// #2622 — RideEditor's ride-load path and its create-missing-sheets path
// each fetch a Test def (`GET /test/:id`) and used to catch EVERY failure
// the same way (`catch { return [id, null]; }`), so a 500, a network drop,
// or an expired token all rendered the exact same "Test definition not
// found for this sheet" wording as a genuine 404 — sending whoever hit a
// real lookup failure off debugging a nonexistent missing-test bug instead
// (measured on #2589: a DynamoDB scan + git log -S, purely because the page
// wouldn't say what actually went wrong). Only a 404 actually means "no
// such test"; every other failure must be kept and surfaced distinctly.
//
// Kept in its own module (no React/MUI/i18n-fe imports) so it unit-tests in
// isolation, rather than paying to import the whole RideEditor.jsx page.

// A genuine 404 classifies as "no error" (null) — the caller's tests[id]
// map stays null with no recorded error, matching today's missing-test
// rendering unchanged. Anything else (other status, or a thrown
// exception/network error with no `response` at all) keeps the error.
export function classifyTestFetchError(err) {
  return err?.response?.status === 404 ? null : err;
}

// The render-site half of the same fix: which alert RideEditor shows once
// the active sheet's test is unresolved. A real getTest failure
// (testFetchError set, per classifyTestFetchError above) gets its own
// distinct message/severity that NAMES the failure (the HTTP status, or
// "network error" when there was no response at all) instead of sending
// the reader to devtools to find it; a genuine 404 (testFetchError
// null/undefined) keeps today's rideEditor.noTest warning. The i18n key
// stays a static source literal per surface convention; only the
// interpolated `values.status` is data.
export function testDefAlertProps(testFetchError) {
  return testFetchError
    ? {
        severity: "error",
        testId: "test-load-error-alert",
        key: "rideEditor.testLoadError",
        values: { status: testFetchError?.response?.status ?? "network error" },
      }
    : { severity: "warning", testId: "no-test-alert", key: "rideEditor.noTest" };
}
